import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cba87310"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapping" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "item-detail"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 1,
  class: "item-detail-en"
}
const _hoisted_8 = ["textContent"]

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeRegardingTransactions',
  props: ['translate'],
  setup(__props) {

const props = __props 

// Notice Regarding Transactions
const transactionsEn = ref(`At this time, we are focusing on serving our existing clients. Updates about future business opportunities will be shared at a later date.`)
const transactionsJa = ref(`当面は現在お取引のあるお客様のご対応に限らせていただいております。
            状況が変わりましたら改めてお知らせいたします。`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.translate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "お取引に関するご案内"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Notice Regarding Transactions"))
    ]),
    (props.translate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", {
            textContent: _toDisplayString(transactionsJa.value)
          }, null, 8, _hoisted_6)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", {
            textContent: _toDisplayString(transactionsEn.value)
          }, null, 8, _hoisted_8)
        ]))
  ]))
}
}

})